import type { AdTemplate } from './schema';

export type TemplateWithBrands = AdTemplate & { brandIds: number[] };

export function filterTemplateCollection<T extends { isGlobal: boolean; brandIds?: number[] }>(
  templates: T[], collection: string,
): T[] {
  if (collection === 'all') return templates;
  return templates.filter((template) => {
    const brandIds = template.brandIds ?? [];
    if (collection === 'catalog') return template.isGlobal;
    if (collection === 'saved') return !template.isGlobal || brandIds.length > 0;
    if (collection === 'unassigned') return !template.isGlobal && brandIds.length === 0;
    return brandIds.includes(Number(collection));
  });
}
